"use client";
import { DescriptionLink } from "@/components/CTA/variants/MultiCourse/descriptions/DescriptionLink";
import { ClientOnly } from "@/components/Cohesion/ClientOnly";
import useTranslations from "@/i18n/useTranslations";

export default function LevelUpDescription() {
  const t = useTranslations("MultiCourse");
  let pos = 0;
  return (
    <ClientOnly>
      <div>
        <p>
          <DescriptionLink
            url="/executive-education"
            text="Executive education programs"
            visibleText={t("executiveEducationProgramsTitle")}
            position={`${++pos}`}
            variant="executive-education-2u"
          />
          &nbsp; {t("levelUpIntroRest")}
        </p>
        <ul className="list-disc">
          <li>{t("levelUpBullet1")}</li>
          <li>{t("levelUpBullet2")}</li>
          <li>{t("levelUpBullet3")}</li>
          <li>{t("levelUpBullet4")}</li>
        </ul>
        <p>
          <i>{t("seekingDegreeExplore")} </i>
          <DescriptionLink
            url="/masters"
            text="master’s degrees"
            visibleText={t("mastersDegreesLower")}
            position={`${++pos}`}
            variant="masters"
          />
          <i> {t("and")} </i>
          <DescriptionLink
            url="/doctorate"
            text="doctorate degrees"
            visibleText={t("doctorateDegrees")}
            position={`${++pos}`}
            variant="doctorate"
          />
          <i>.</i>
        </p>
      </div>
    </ClientOnly>
  );
}
